<template>
	<div class="relative-wrapper">
		<header class="header" :class="[showHeader ? 'show-header' : 'hide-header']">
			<div class="menu-bar">
				<a href="#" @click.prevent="openMenu">
					<ion-icon name="list"></ion-icon>
				</a>
			</div>
			<div class="logo" data-test="header-text">
				<router-link to="/" class="short-title">
					S
					<span class="sub-title">{{$store.state.app.app.subTitle}}</span>
				</router-link>
			</div>
			<div v-if="$store.state.user.authUser !== null" class="header-buttons">
				<span>
					<div class="notifications-link" @click.stop="showNotificationsSubMenu">
						<ion-icon name="ios-notifications"></ion-icon>
						<span
							v-if="notificationCount > 0"
							class="stackng-notification"
							:title="`You have ${notificationCount} Notifications`"
						></span>
						<div class="notifications-sub-menu" style="display:none">
							<notifications-list></notifications-list>
						</div>
					</div>
				</span>
				<span v-if="$store.state.user.user.username">
					<a class="groups-link" @click.prevent="showGroups">
						<ion-icon name="ios-contacts"></ion-icon>
					</a>
				</span>
				<span v-if="$store.state.user.user.username">
					<router-link :to="{path: `/s/${$store.state.user.user.username}`}" class="timeline-link">
						<ion-icon name="logo-buffer" class="logo-buffer"></ion-icon>
					</router-link>
				</span>
				<span>
					<div class="photo-link" @click.stop="showProfileSubMenu">
						<img v-if="photoURL" :src="$store.state.user.user.photoURL" alt="Profile picture" />
						<ion-icon v-else name="contact"></ion-icon>
						<ul class="profile-sub-menu" style="display:none">
							<li>
								<router-link tag="a" :to="{path: `/profile/${profileRouteParam}`}">
									<ion-icon name="ios-contact"></ion-icon>&nbsp;
									Profile
								</router-link>
							</li>
							<li>
								<a @click.prevent="signOut">
									<ion-icon name="log-out"></ion-icon>&nbsp;
									Sign Out
								</a>
							</li>
						</ul>
					</div>
				</span>
			</div>
			<div v-else class="header-buttons">
				<router-link to="/auth" tag="a" class="sign-in-link button stackng-button">Sign In</router-link>
			</div>
		</header>
	</div>
</template>

<script>
import axios from "axios";
import { groupsMixin } from "../mixins/groupsMixin";
import { notificationsMixin } from "../mixins/notificationsMixin";
import NotificationsList from "./notifications/NotificationsList.vue";

export default {
	mixins: [groupsMixin, notificationsMixin],
	components: {
		NotificationsList
	},
	mounted() {
		let prevScrollpos = window.pageYOffset;
		const _this = this;

		window.onscroll = function() {
			var currentScrollPos = window.pageYOffset;
			let timelineTab = window.document.querySelector("#timeline .tabs");
			let header = window.document.querySelector(".header");
			let shownHeader = window.document.querySelector(".show-header");
			let bottomNav = window.document.querySelector(".bottom-nav");

			if (timelineTab !== null) {
				if (window.innerWidth <= 730) {
					timelineTab.style.top = shownHeader !== null ? "50px" : "0px";
				} else if (window.innerWidth <= 940) {
					if (currentScrollPos <= 0) {
						timelineTab.style.top = "60px";
					} else {
						timelineTab.style.top = shownHeader !== null ? "50px" : "0px";
					}
				} else {
					timelineTab.style.top = shownHeader !== null ? "50px" : "0px";
				}
			}

			if (prevScrollpos > currentScrollPos) {
				if (window.innerWidth <= 940) {
					_this.$store.state.app.app.showHeader = true;

					if (window.innerWidth <= 540 && bottomNav) {
						bottomNav.style.paddingBottom = "0px";
						bottomNav.style.height = "50px";
					}
				} else {
					_this.$store.state.app.app.showHeader = true;
				}
			} else {
				if (window.innerWidth <= 540 && bottomNav) {
					bottomNav.style.paddingBottom = "30px";
					bottomNav.style.height = "80px";
				}
				_this.$store.state.app.app.showHeader = false;
			}

			if (currentScrollPos <= 0 && bottomNav) {
				_this.$store.state.app.app.showHeader = true;
				bottomNav.style.paddingBottom = "0px";
				bottomNav.style.height = "50px";
			}
			prevScrollpos = currentScrollPos;
		};
	},
	computed: {
		showHeader() {
			return this.$store.state.app.app.showHeader;
		},
		profileRouteParam() {
			return this.$store.state.user.user.username !== ""
				? this.$store.state.user.user.username
				: this.$store.state.user.authUser.uid;
		},
		photoURL() {
			return this.$store.state.user.user.photoURL === "" ||
				this.$store.state.user.user.photoURL === undefined
				? false
				: true;
		},
		notificationCount() {
			return this.$store.getters.getNotifications.length;
		}
	},
	methods: {
		openMenu() {
			this.$store.state.app.app.menuOpen = true;
			this.$store.state.app.app.activityBarOpen = false;
		},

		showNotifications() {
			this.showNotificationsModal();
		},
		showGroups() {
			this.showGroupsModal();
		},
		showNotificationsSubMenu() {
			const app = document.querySelector("#app");
			const notifSubMenu = window.document.querySelector(
				".notifications-sub-menu"
			);

			notifSubMenu.style.display =
				notifSubMenu.style.display === "none" ? "block" : "none";

			app.addEventListener("click", () => {
				notifSubMenu.style.display = "none";
			});
		},
		showProfileSubMenu() {
			const app = document.querySelector("#app");
			const subMenu = window.document.querySelector(".profile-sub-menu");

			subMenu.style.display =
				subMenu.style.display === "none" ? "block" : "none";

			app.addEventListener("click", () => {
				subMenu.style.display = "none";
			});
		},
		signOut() {
			this.$store.dispatch("signOut");
			this.$router.push("/auth");
		}
	}
};
</script>
<style scoped>
.relative-wrapper {
	height: 50px;
}

.header {
	position: fixed;
	width: 100%;
	transition: all 0.3s ease;
	z-index: 10;
	height: 50px;
	-webkit-overflow-scrolling: auto;
	background-color: #000c;
	display: flex;
	align-items: center;
	padding: 0px 20px;
}

.show-header {
	top: 0px;
}

.hide-header {
	top: -50px;
}

.header-buttons {
	width: 30%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.logo {
	width: 40%;
	text-align: center;
}

.full-title,
.short-title {
	font-family: "Monoton", "Avenir", Helvetica, Arial, sans-serif;
	letter-spacing: 1px;
	font-size: 25px;
	color: #51c715;
}

.full-title {
	display: none;
}

.sub-title {
	font-size: 12px;
	font-family: "Teko", sans-serif;
	vertical-align: super;
}

.photo-link,
.timeline-link,
.notifications-link,
.groups-link {
	color: #51c715;
	border-radius: 50%;
	font-size: 18px;
	padding: 3px;
	transition: 0.3s all;
	vertical-align: -webkit-baseline-middle;
	position: relative;
	cursor: pointer;
}

.photo-link {
	padding-right: 0px;
}

.photo-link img {
	border-left: 2px solid #51c715;
	border-right: 2px solid #51c715;
	border-top: 2px solid #000;
	border-bottom: 2px solid #000;
	padding: 2px;
	transition: 0.3s all ease;
}

.photo-link img:hover {
	border-left-color: #000;
	border-right-color: #000;
	border-top-color: #51c715;
	border-bottom-color: #51c715;
}

.menu-bar {
	width: 30%;
}

.menu-bar a {
	color: #51c715;
}

.menu-bar ion-icon {
	font-size: 30px;
}

.header-buttons a {
	border: none;
}

.header-buttons ion-icon {
	font-size: 30px;
}

.header-buttons span p {
	font-size: 9px;
	margin-top: -10px;
	margin-right: -3px;
}

.header-buttons img {
	height: 35px;
	width: 35px;
	object-fit: cover;
	border-radius: 50%;
}

.logo-buffer {
	margin-right: 3px;
}

.sign-in-link {
	background-color: #484848;
	margin-right: 0px;
}

.sign-in-link ion-icon {
	font-size: 17px !important;
	vertical-align: middle;
}

.dateTime,
.weather,
.hello {
	font-weight: bold;
	font-size: 9px;
}

.dateTime {
	width: 50%;
}

.hello {
	width: 50%;
	text-align: right;
}

.weather {
	justify-content: flex-end;
}

.profile-sub-menu,
.notifications-sub-menu {
	position: absolute;
	right: 0;
	background-color: #111;
	/* padding: 15px; */
	-webkit-box-shadow: 1px 6px 9px 2px rgba(0, 0, 0, 0.75);
	-moz-box-shadow: 1px 6px 9px 2px rgba(0, 0, 0, 0.75);
	box-shadow: 1px 6px 9px 2px rgba(0, 0, 0, 0.75);
	width: 200px;
	border-radius: 10px;
	text-align: left;
	z-index: 999999;
	display: none;
	transition: 0.3s ease all;
	animation: sub-menu-fade 0.3s linear;
}

.profile-sub-menu li a {
	font-weight: 700;
	display: block;
	font-size: 13px;
	padding: 10px 15px;
	margin: 10px;
	color: #b7b7b7;
	transition: 0.3s ease all;
	border-radius: 10px;
	display: flex;
	align-items: center;
}

.profile-sub-menu li a ion-icon {
	font-size: 20px;
}

.profile-sub-menu li:last-of-type a {
	color: red !important;
}

.profile-sub-menu li a:hover {
	background-color: #171717;
	color: #fff;
}

.notifications-sub-menu {
	min-width: 450px;
}

@media only screen and (min-width: 1376px) {
	.header-container {
		width: 1280px;
	}
}

@media only screen and (max-width: 940px) {
	.content h4 {
		font-size: 14px;
	}

	.hello {
		width: 100%;
	}

	.header-buttons span p {
		display: none;
	}
}

@media only screen and (max-width: 540px) {
	.notifications-link,
	.groups-link,
	.timeline-link {
		display: none;
	}
}

@media only screen and (max-width: 500px) {
	.header-buttons {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.header-buttons > div {
		height: 100%;
	}

	.header-buttons img {
		height: 30px;
		width: 30px;
	}

	.sign-in-link {
		margin-right: 0px;
		font-size: 12px;
		font-weight: 400;
		height: fit-content;
		border-radius: 5px;
		padding: 3px 12px 5px 12px;
	}
}

@keyframes sub-menu-fade {
	0% {
		opacity: 0;
	}
	50% {
		opacity: 0.5;
	}
	100% {
		opacity: 1;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue